//Parroquias merida
const munAlbertoAdriani = [
  'Presidente Betancourt',
  'Presidente Páez',
  'Presidente Rómulo Gallegos',
  'Gabriel Picón González',
  'Héctor Amable Mora',
  'José Nucete Sardi ',
  'Pulido Méndez',
];
const munAndrésBello = ['Andrés Bello'];
const munAntonioPintoSalinas = [
  'Capital Pinto Salinas',
  'Mesa Bolívar',
  'Mesa De Las Palmas',
];
const munAricagua = ['Aricagua', 'San Antonio'];
const munArzobispoChacón = [
  'Arzobispo Chacón',
  'Capurí',
  'Chacantá',
  'El Molino',
  'Guaimaral',
  'Mucutuy',
  'Mucuchachí',
];
const munCampoElías = [
  'Fernández Peña',
  'Matriz',
  'Montalbán',
  'Acequias',
  'Jají',
  'La Mesa',
  'San José del Sur',
];
const munCaraccioloParraOlmedo = [
  'Caracciolo Parra Olmedo',
  'Florencio Ramírez',
];
const munCardenalQuintero = ['Cardenal Quintero', 'Las Piedras'];
const munGuaraque = ['Guaraque', 'Mesa De Quintero', 'Río Negro'];
const munJulioCésarSalas = ['Julio César Salas', 'Palmira'];
const munJustoBriceño = ['Justo Briceño', 'San Cristobal De Torondoy'];
const munLibertadorMerida = [
  'Antonio Spinetti Dini',
  'Arias',
  'Caracciolo Parra Pérez',
  'Domingo Peña',
  'El Llano',
  'Gonzalo Picón Febres',
  'Jacinto Plaza',
  'Juan Rodríguez Suárez',
  'Lasso De La Vega',
  'Mariano Picón Salas',
  'Milla',
  'Osuna Rodríguez',
  'Sagrario',
  'El Morro',
  'Los Nevados',
];
const munMirandaMerida = [
  'Miranda',
  'Andrés Eloy Blanco',
  'La Venta',
  'Piñango ',
];
const munObispoRamosDeLora = [
  'Obispo Ramos De Lora',
  'Eloy Paredes',
  'San Rafael De Alcázar',
];
const munPadreNoguera = ['Padre Noguera'];
const munPuebloLlano = ['Pueblo Llano'];
const munRangel = ['Rangel', 'Cacute', 'La Toma', 'Mucurubá', 'San Rafael'];
const munRivasDávila = ['Rivas Dávila', 'Gerónimo Maldonado'];
const munSantosMarquina = ['Santos Marquina'];
const munSucreMerida = [
  'Sucre',
  'Chiguará',
  'Estánquez',
  'La Trampa',
  'Pueblo Nuevo Del Sur',
  'San Juan',
];
const munTovarMerida = ['El Amparo', 'El Llano', 'San Francisco', 'Tovar'];
const munZea = ['Zea', 'Caño El Tigre'];
const munTulioFebresCordero = [
  'Tulio Febres Cordero',
  'Independencia',
  'María De La Concepción Palacios Y Blanco',
  'Santa Apolonia',
];
export const esMerida = [
  {
    municipio: 'Alberto Adriani',
    parroquias: munAlbertoAdriani,
  },
  {
    municipio: 'Andrés Bello',
    parroquias: munAndrésBello,
  },
  {
    municipio: 'Antonio Pinto Salinas',
    parroquias: munAntonioPintoSalinas,
  },
  {
    municipio: 'Aricagua',
    parroquias: munAricagua,
  },
  {
    municipio: 'Arzobispo Chacón',
    parroquias: munArzobispoChacón,
  },
  {
    municipio: 'Campo Elías',
    parroquias: munCampoElías,
  },
  {
    municipio: 'Caracciolo Parra Olmedo',
    parroquias: munCaraccioloParraOlmedo,
  },
  {
    municipio: 'Cardenal Quintero',
    parroquias: munCardenalQuintero,
  },
  {
    municipio: 'Guaraque',
    parroquias: munGuaraque,
  },
  {
    municipio: 'Julio César Salas',
    parroquias: munJulioCésarSalas,
  },
  {
    municipio: 'Justo Briceño',
    parroquias: munJustoBriceño,
  },
  {
    municipio: 'Libertador',
    parroquias: munLibertadorMerida,
  },
  {
    municipio: 'Miranda',
    parroquias: munMirandaMerida,
  },
  {
    municipio: 'Obispo Ramos De Lora',
    parroquias: munObispoRamosDeLora,
  },
  {
    municipio: 'Padre Noguera',
    parroquias: munPadreNoguera,
  },
  {
    municipio: 'Pueblo Llano',
    parroquias: munPuebloLlano,
  },
  {
    municipio: 'Rangel',
    parroquias: munRangel,
  },
  {
    municipio: 'Rivas Dávila',
    parroquias: munRivasDávila,
  },
  {
    municipio: 'Santos Marquina',
    parroquias: munSantosMarquina,
  },
  {
    municipio: 'Sucre',
    parroquias: munSucreMerida,
  },
  {
    municipio: 'Tovar',
    parroquias: munTovarMerida,
  },
  {
    municipio: 'Zea',
    parroquias: munZea,
  },
  {
    municipio: 'Tulio Febres Cordero',
    parroquias: munTulioFebresCordero,
  },
];
